<template>
    <div @mouseenter="collapsed=false" @mouseleave="collapsed=true"
         :class="' p3sidebar ' + (collapsed? ' collapsed ':'')" ref="sidebar-cnt">

        <div class="user">
            <user-avatar :user="currentUser" />
            <span class="info">
                {{currentUser.first_name}} {{currentUser.second_name}}
                <router-link :to="{name: 'logout'}" class="logout"><b-icon icon="box-arrow-right"/></router-link>
            </span>
        </div>

        <div :class="' timer '  + (currentTask ? ' has-task ' : ' no-task ')">
            <div class="logo">
                <b-icon @click="stopTimer" :icon="currentTask ? ' stop-fill ' : ' exclamation-triangle '"/>
                <template v-if="currentTask">
                    {{$api.getTimeFromSeconds(currentTask.time_spent)}}
                </template>
            </div>

            <div class="info">
                <b-link v-if="currentTask" :to="{name: 'tree', params: {task_id: currentTask.id}}">{{currentTask.rendered_title}}</b-link>
                <span v-else>Please choose the task and start the timer</span>
            </div>

            <div style="clear:both;"></div>

        </div>


        <div class="menu">
            <template v-for="(m, k) in menu">
                <a :key="'mi-'+k" :class="' item ' + (m.badge > 0 ? 'has-badge' : '')"
                   v-if="(!m.roles || $get('auth/checkCurrentRoleInList', m.roles)) && !m.invisible"
                   @click="clickOn(m)">
                    <b-icon class="logo" v-if="m.icon" :icon="m.icon"/>
                    <div class="notcount" v-if="m.badge"><i>{{m.badge}}</i></div>

                    {{m.title}}
                    <b-icon class="expand" v-if="m.children" icon="arrow-down"/>
                </a>

                <template v-if="m.expanded">
                    <template v-for="(c, ck) in m.children">
                        <a :key="'ci-'+ k +'-'+ck" class="child"
                           v-if="(!c.roles || $get('auth/checkCurrentRoleInList', c.roles)) && !c.invisible" @click="clickOn(c)">
                            <b-icon v-if="c.icon" :icon="c.icon"/>
                            {{c.title}}
                        </a>
                    </template>
                </template>
            </template>
        </div>

    </div>
</template>

<script>

    import UserAvatar from "./UserAvatar";

    export default {

        components: {UserAvatar},
        data: () => ({
            collapsed: true,

        }),

        watch: {
            'collapsed': 'onToggle'
        },

        /**
         * Created time
         */

        created() {

            // Init interval timer
            let timer = this.$get("system/getVar", "tlTimer");

            // Set interval
            if (!timer) {
                // Init
                timer = setInterval(this.incTaskTime, 1000);

                // Create
                this.$dispatch("system/setVar", {var: "tlTimer", val: timer});
            }

        },

        // App mounted
        mounted() {
            // Load lists
            //this.$dispatch("tree/loadTreeLists");

            // Load current users task
            this.$dispatch('tree/loadCurrent').then((d) => {

                // Load task if started
                if(d && d.id) {
                    this.$dispatch('tree/loadTask', d.id)
                }
            });

        },

        computed: {

            /**
             * Return tables list
             */

            menu() {

                // Load tables list
                let list = [];

                // Return menu items
                this.$get('tree/getTablesList').map(el => {
                    list.push({
                        title: el.rendered_title,
                        to: {name: "table", params: {task_id: el.id}}
                    });
                });

                return this.$api.reactObject([
                  {
                    title: 'Profile',
                    to: {name: 'profile'},
                    icon: 'person-circle',
                  },

                  {
                        title: 'Statistics',
                        to: {name: 'home'},
                        icon: 'pie-chart'
                    },
                    {
                        title: 'HR Zone',
                        icon: 'person-lines-fill',
                        invisible:  !this.$get("taskuser/getTasksByRoles", {user: this.currentUser, role: "hr"}).length &&
                                    !this.$get("taskuser/getTasksByRoles", {user: this.currentUser, role: "manager"}).length &&
                                    !this.$get("auth/checkCurrentRoleInList","finance"),
                        expanded: false,
                        children: [
                            {
                                title: 'Users',
                                to: {name: 'users-load'},
                                invisible: !this.$get("taskuser/getTasksByRoles", {user: this.currentUser, role: "manager"}).length,
                            },
                            /*{
                                title: 'Positions',
                                to: {name: 'hr'},
                                invisible: !this.$get("taskuser/getTasksByRoles", {user: this.currentUser, role: "hr"}).length
                            },*/

                            {
                                title: 'Users list',
                                to: {name: 'users'},
                                roles: ['admin']

                            },
                            {
                                title: 'Reports',
                                to: {name: 'users-report'},
                                roles: ['admin', 'finance'],
                                //invisible: !this.$get("taskuser/getTasksByRoles", {user: this.currentUser, role: "hr"}).length
                            },

                        ]
                    },
                    {
                        title: 'Tree',
                        to: {name: 'tree'},
                        icon: 'diamond',
//                        invisible: !this.$get("tree/getTasksList", 0).length
                    },
                    /*{
                        title: 'Lists',
                        icon: 'list-task',
                        children: list,
                        expanded: true,
                        invisible: !list.length
                    },*/

                ]);
            },

            /**
             * Get current user obj
             */
            currentUser() {
                return this.$store.getters['auth/currentUser'];
            },

            /**
             * Current active task
             */
            currentTask() {
               // Return current task
                return this.$get("tree/getCurrent");
            },


            /**
             * Current notifications count
             */
            currentNotificationsCount() {

                // Get notifications
                const nots = this.$get("notifications/getUsersComments");

                // Counter
                let cnt = 0;

                // Check notifications count
                for(const n of nots) {

                    // Get task
                    const t = this.$get("tree/getTaskByID", n.source_id);

                    // Skip task
                    if(!t) continue;

                    // task is on acceptance
                    if (!(this.checkRole(t, "acceptor") || this.checkRole(t, "assignee") || this.checkRole(t, "follower"))) return false;

                    // Increase counter
                    cnt++;
                }

                // Return current task
                return cnt;
            }


        },

        methods: {

            // Increase task time
            incTaskTime() {
                this.$dispatch("tree/incCurTime1sec");
            },


            /**
             * Check for the task role
             */

            checkRole(task, role) {
                return !!this.$get("taskuser/getUserRoles", {
                    task_id: task.id,
                    user: this.currentUser,
                    role: role
                }).length;
            },

            // Stop timer
            stopTimer() {
                // Stop task
                this.$dispatch("tree/stop").then(() => {

                    // Get current page
                    let cur = this.$get("tree/getCurrent");

                    // Open page
                    if(cur) this.$router.push({name: 'tree', params: {task_id: cur.id}}).catch(()=>{});
                });
            },

            /**
             * On toggle
             */

            onToggle() {

                // Scroll top
                if (this.collapsed) {
                    this.$refs['sidebar-cnt'].scrollTop = 0;
                }
            },

            /**
             * Click menu item handler
             * @param item
             */
            clickOn(item) {

                // Goto page
                if (item.to) {
                    this.$router.push(item.to)
                    this.collapsed = true;
                } else {
                    item.expanded = item.expanded ? false : true;
                }
            }

        }
    }
</script>


<style lang="scss">

    .p3sidebar.collapsed .info {
        display: none !important;
    }

    .p3sidebar {
        z-index: 10;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        background: #232934;
        color: #ddd;
        width: 250px;
        //box-shadow: 5px 0px 10px #0003;
        overflow-x: hidden;
        overflow-y: auto;

        .timer.no-task {
            color:white;
            background: #a00;

            .b-icon {
                margin-top:7px !important;
            }
        }

        .timer.has-task {
            color: #0a0;
            border-bottom: 1px dashed #555;
        }

        .timer {
            padding:10px 0px 10px 0px;
            font-size: 14px;
            height: 60px;

            .logo {
                float: left;
                width: 50px;
                text-align: center;
                font-size: 12px;

                .b-icon {
                    width:25px;
                    height: 25px;
                    margin: 0px 10px 0px 10px;
                    cursor: pointer;
                }
            }

            .info {
                padding-top:3px;
                padding-right: 10px;
                margin-left:50px;
                height: 40px;
                overflow: hidden;
                display: block;
            }

            .info a {
                color:#ddd;
                text-decoration: none;
            }

            .info a:hover {
                text-decoration: underline;

            }
        }

        .menu {
            padding: 10px;

            .notcount {
                margin-top:-7px;
                position: absolute;
                width:35px;
                line-height: 16px;
                text-align: right;

                i {
                    background: #a00;
                    font-size: 10px;
                    font-style: normal;
                    padding: 0px 2px 1px 2px;
                    line-height: 12px;
                    border-radius:5px;
                    min-width: 12px;
                    display: inline-block;
                    text-align: center;
                    animation: blinker 2s linear infinite;
                }
            }

            .item.has-badge .logo {
                border-color: #800;
            }

            .child, .item {

                color: #ddd;
                text-decoration: none;


                .expand {
                    margin-top: 7px;
                    margin-left: 5px;
                }

                .logo {
                    color: #888;
                    border-radius: 5px;
                    width: 30px;
                    height: 30px;
                    padding: 4px;
                    margin-right: 10px;
                    //background: #101523;
                    border:1px solid #444;
                }

                line-height: 30px;
                height: 30px;
                display: flex;
                margin-top: 10px;
                cursor: pointer;
            }

            .child:hover,
            .item:hover {
                background: #fff1;
                border-radius: 5px;
            }

            .child {
                margin-left: 30px;
                padding-left: 10px;
                margin-bottom: 5px;
                line-height: 20px;
                height: 20px;
                font-size: 0.8em;
                overflow: hidden;
            }

        }

        .user {
            padding: 10px;
            height: 50px;
            color: #ddd;
            &>div {
                width: 30px;
                height: 30px;
                display: inline-block;
                margin-right: 20px;
            }
            .b-avatar {
                width: 30px !important;
                height: 30px !important;
                max-width: none;
                margin-right: 5px !important;
            }

            .info a {
                margin-top: 4px;
                color: white;
                text-decoration: none;
            }

            .info .logout {
                float: right;
            }

            background: #101523;
        }

    }

    .collapsed {
        width: 50px;
        overflow-y: hidden;
    }

</style>
